// --- Client-requested / default groups (not A/B tests) ---

// The default prompt/model recipe. The llm service also resolves any unregistered prompt group to
// this one (getPromptGroupConfig), so it doubles as the fallback.
export const DEFAULT_PROMPT_GROUP = 'DEFAULT'

// Requested explicitly by the client for the "Finish notes" flow — the user's own notes drive the
// summary's structure and emphasis. Deliberately excluded from ACTIVE_LEARN_AB_TESTS so it does not
// perturb the batch content hash.
export const USER_GUIDED_PROMPT_GROUP = 'USER_GUIDED'

// Sent by the web client for non-Pro users. Intentionally has no registered prompt group in the llm
// service, so getPromptGroupConfig resolves it to DEFAULT_PROMPT_GROUP.
export const QUIZ_PREFETCH_PROMPT_GROUP = 'QUIZ_PREFETCH_V1'

// --- A/B test groups ---
// A group's membership in ACTIVE_LEARN_AB_TESTS is behaviorally load-bearing: those groups are
// folded into the batch content hash (buildStudyMaterialsBatchContentHash) so each variant gets its
// own cache entry.

// Smart Notes prompt group which gets called any time a PRO subscriber requests a summary
// TODO: The business logic of this prompt group needs to be moved into the backend
export const SMART_NOTES_PROMPT_GROUP_V1 = 'SMART_NOTES_V1'
export const SMART_NOTES_PROMPT_GROUP_V2 = 'SMART_NOTES_V2'

// AB test for terse smart notes prompt (matches experiment flag name app_terseSmartNotes)
export const TERSE_SMART_NOTES_PROMPT_GROUP = 'TERSE_SMART_NOTES'

// The A/B test groups whose presence changes the batch content hash. The hashing and
// subscriber-assignment logic that consumes this list lives in common-backend's llm_ab_testing.ts.
export const ACTIVE_LEARN_AB_TESTS = Object.freeze([
  SMART_NOTES_PROMPT_GROUP_V1,
  SMART_NOTES_PROMPT_GROUP_V2,
  TERSE_SMART_NOTES_PROMPT_GROUP
])
